import {useMemo} from 'react';

import {Asset} from '@deviceinsight/ng-ui-api-client';

import {KpiWidgetItem} from '../types';
import useAssetsByUrns from './useAssetsByUrns';
import {WidgetProps} from '@deviceinsight/ng-ui-scale-lib/api';
import {nonNull} from '../../../../../utils/tsUtils';

const useAssetsFromConfig = (items: KpiWidgetItem[], context: WidgetProps['context']): Asset[] => {
	const assetsFromItems = useAssetsByUrns(
		context.type === 'asset' ? [] : items.map(({assetUrn}) => assetUrn).filter(nonNull)
	);

	return useMemo(() => (context.type === 'asset' ? [context.asset] : assetsFromItems), [assetsFromItems, context]);
};

export default useAssetsFromConfig;
